import $ from 'jquery';
import { scrollPositionToMiddle } from '../utils';

let rankingResultsScrollPosition: number | null = null;

export function setupHomePage() {
  const loadMoreButton = $('#load-more-activities-button');
  if (!loadMoreButton) {
    return;
  }

  loadMoreButton.on('click', onLoadMoreActivities);
}

function onLoadMoreActivities(e: JQuery.ClickEvent) {
  const button = $(e.target);
  const activitiesCount = button.data('activities-count');
  const results = document.getElementById('politician-rankings-result');

  if (!rankingResultsScrollPosition) {
    rankingResultsScrollPosition = results.getBoundingClientRect().bottom;
  }

  button.addClass('button--loading');

  $.get('/topRankings', { count: activitiesCount }, (result) => {
    results.innerHTML = result;
    button.removeClass('button--loading');
    scrollPositionToMiddle(rankingResultsScrollPosition);
  });
}
